/**
 * Access level for department resources. bearer-manager is viewer plus the bearer and card operations on travellers and tickets.
 */
export type DepartmentAccessLevelDTO =
  (typeof DepartmentAccessLevelDTO)[keyof typeof DepartmentAccessLevelDTO];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DepartmentAccessLevelDTO = {
  none: 'none',
  viewer: 'viewer',
  'bearer-manager': 'bearer-manager',
  editor: 'editor',
} as const;
